import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Field, useFormState } from 'react-final-form';
import {
  SimpleSelectField,
} from '@unite-us/app-components';
import formatOptions from 'common/utils/formatOptions';
import {
  MilitaryServiceFields,
  MilitaryDeploymentFields,
  MilitaryDisabilityProofFields,
} from './components';

// TODO: remove MILITARY_FORM_NAME once NewCaseView is migrated off redux-form destroy()
export const MILITARY_FORM_NAME = 'contact_military';

const getFieldError = (meta) => (meta.touched && meta.error ? meta.error : undefined);

/** Returns '' when visible, 'hidden' when not — used for className toggling. */
const visibilityClass = (isVisible) => (isVisible ? '' : 'hidden');

function MilitaryMemberFields({ militaryEnums }) {
  const { values } = useFormState({ subscription: { values: true } });

  const isDeployed = values.deployed === 'yes';
  const hasDisabilityRating = values.service_connected_disability === 'yes';
  const hasProof = values.proof_of_veteran_status === 'yes';

  return (
    <>
      <MilitaryServiceFields militaryEnums={militaryEnums} />
      <MilitaryDeploymentFields militaryEnums={militaryEnums} isDeployed={isDeployed} />
      <MilitaryDisabilityProofFields
        militaryEnums={militaryEnums}
        hasDisabilityRating={hasDisabilityRating}
        hasProof={hasProof}
      />
    </>
  );
}

MilitaryMemberFields.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
};

export function MilitaryForm({ enums }) {
  const { values } = useFormState({ subscription: { values: true } });

  const onAffiliationChange = () => {
    setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
  };

  const militaryEnums = _.wget(enums, 'military', {});
  const isMilitaryMember = values.affiliation === 'military_member_or_veteran';

  return (
    <div className="military-form content-with-actions">
      <div className="content-container content-container--medium">
        <Field name="affiliation">
          {({ input, meta }) => (
            <SimpleSelectField
              id="affiliation"
              label="Affiliation"
              value={input.value}
              onChange={(value) => {
                input.onChange(value);
                onAffiliationChange();
              }}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.affiliation)}
              optionSettings={{ labelKey: 'label', valueKey: 'value' }}
              error={getFieldError(meta)}
            />
          )}
        </Field>
        <div className={visibilityClass(isMilitaryMember)}>
          <MilitaryMemberFields militaryEnums={militaryEnums} />
        </div>
      </div>
    </div>
  );
}

MilitaryForm.propTypes = {
  enums: PropTypes.object.isRequired,
};

MilitaryForm.fields = [
  'affiliation',
  'current_status',
  'currently_transitioning',
  'at_least_one_day_active_duty',
  'branch',
  'service_era',
  'entry_date',
  'exit_date',
  'deployed',
  'deployment_starts_at',
  'deployment_ends_at',
  'discharge_type',
  'discharged_due_to_disability',
  'service_connected_disability',
  'service_connected_disability_rating',
  'proof_of_veteran_status',
  'proof_type',
];

function mapStateToProps(state) {
  return {
    enums: _.wget(state, 'session.enums.contact_data', {}),
  };
}

export default connect(mapStateToProps)(MilitaryForm);
